import {IonAvatar, IonBadge, IonButton, IonCol, IonIcon, IonNote, IonRouterLink, IonText, useIonAlert, useIonRouter} from "@ionic/react";
import styles_CardDetailFor_7_3 from "./CardDetailFor_7_3.module.scss";
import styles_ContractBonusItem from "./ContractBonusItem.module.scss";
import {bookmark, bookmarkOutline, chatboxEllipses, chatboxEllipsesOutline, heart, heartOutline, star} from "ionicons/icons";
import Ln_TokenPictureSetCoverImg from "../pages/Ln_TokenPictureSetCoverImg";
import {ActionLink} from "./ActionLink";
import styles_Common from "../pages/Common.module.scss";
import moment from "moment";
import QRCode from "react-qr-code";
import styles_CardDetailFor_7_2 from "./CardDetailFor_7_2.module.scss";
import {navToPg_7_2_2, navToPg_7_5, promptBrowserToLogin} from "../pages/Utils";
import {push_pg_4_2__AddCouponBookmark} from "../store/Pg_4_Store";
import {push_pg_7_3_1_JoinEvent, push_pg_7_3_1_QuitEvent} from "../store/Pg_7_Store";
import {useStoreState} from "pullstate";
import {AuthStore, UserEventActivityStore, UserPostFavorStore} from "../store/Common_Store";
import {getPageData} from "../store/Selectors";
import styles_ContractBonusDetailItem from "./ContractBonusDetailItem.module.scss";
import {Fragment} from "react";
import useForceRender from "../_/useForceRender";

export const CardDetailFor_7_3_1 = ({
                                        Item_Sdgs活動, JoinEventState, QrCode, reload,
                                        fromHome = false,
                                        noLink = false,
                                        onClickCapture = null as any
                                    }) => {
    const router = useIonRouter();
    const Dict_會員_Sdgs活動__參加 = useStoreState(UserEventActivityStore, getPageData);
    const forceRender = useForceRender();

    ///#region 會員
    const authStore = useStoreState(AuthStore, getPageData);
    const hasAuthed = authStore?.signBy ?? false;
    const Item_會員 = hasAuthed ? authStore?.AuthData : undefined;
    ///#endregion

    const [presentAlert] = useIonAlert();

    if (!Item_Sdgs活動) {
        return <>(ERROR:Item_Sdgs活動)</>;
    }

    let _活動城市: any = Item_Sdgs活動?._活動城市;
    if (!_活動城市) {
        return <>(ERROR:_活動城市)</>;
    }


    const _push_pg_7_3_1__quitevent = async (eventId) => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        if (await push_pg_7_3_1_QuitEvent({
            p1: eventId,
        })) {
            //navToPg_1_1();
            reload();
        }
    }

    const _push_pg_7_3_1__joinevent = async (eventId) => {
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        if (await push_pg_7_3_1_JoinEvent({
            p1: eventId,
        })) {
            //navToPg_1_1();
            await reload();

            presentAlert({
                backdropDismiss: true,
                keyboardClose: true,
                header: '歡迎您參與活動！',
                //subHeader: 'A Sub Header Is Optional',
                message: Item_Sdgs活動.活動名稱,
                buttons: [
                    {
                        text: '查詢積分紀錄',
                        role: 'confirm',
                        handler: () => {
                            navToPg_7_5(router);
                        },
                    },
                    {
                        text: '了解',
                        role: 'cancel',
                        handler: () => {
                            //reload();
                        },
                    },
                ]
            })
        }
    }

    const start = async () => {
        // const platforms = getPlatforms();
        // const isWeb = (platforms.includes("desktop") || platforms.includes("mobileweb") || platforms.includes("pwa"));
        //
        // if (!isWeb) {
        //     const data = await BarcodeScanner.scan();
        //     if (data) {
        //         handleSuccess(data);
        //     }
        // } else {
        //     presentWebModal({
        //         presentingElement: pageRef.current
        //     });
        // }
        if (!hasAuthed) {
            promptBrowserToLogin();
            return;
        }

        navToPg_7_2_2(router, 1);
    }

    return (
        <>
            <ActionLink link={`/tabs/7_3_1/${Item_Sdgs活動.合約獎勵Id}`} className={styles_CardDetailFor_7_3.container} noLink={noLink} onClickCapture={onClickCapture}>
                <div className={styles_CardDetailFor_7_3.postBar}>
                    {Ln_TokenPictureSetCoverImg({
                        圖片組: Item_Sdgs活動.封面組,
                        名稱: 'cover',
                    })}
                </div>

                <div className={styles_CardDetailFor_7_3.containerInner}>

                    <div className={styles_CardDetailFor_7_3.titleBar}>
                        {Item_Sdgs活動.活動名稱}
                    </div>

                    <div className={styles_ContractBonusItem.timeRangeBar}>
                        {moment(Item_Sdgs活動.開始時間).format('YYYY/MM/DD  hh:mm A')} {Item_Sdgs活動._活動城市.顯示名稱}
                    </div>

                    <div className={styles_ContractBonusItem.timeRangeBar}>
                        {Item_Sdgs活動.地址}
                    </div>

                    <div className={styles_ContractBonusItem.timeRangeBar}>
                        積分: +{Item_Sdgs活動.完成可獲得點數}
                    </div>

                    <div className={styles_ContractBonusItem.timeRangeBar}>
                        {Item_Sdgs活動.分類組}
                    </div>

                    <div className={styles_ContractBonusItem.timeRangeBar}>
                        目前報名參加人數: {Item_Sdgs活動.參加人數}
                    </div>


                    {Dict_會員_Sdgs活動__參加[Item_Sdgs活動.Sdgs活動Id] && <Fragment>
                        <Fragment>
                            <IonButton disabled={true} className={styles_CardDetailFor_7_2.buttonCanDo} fill={"solid"} expand="block">
                                {JoinEventState}
                            </IonButton>
                        </Fragment>

                        {JoinEventState === "已參加活動" && <Fragment>
                            <div className={styles_ContractBonusDetailItem.redeemBar}>
                                <div className="l">入場時請向工作人員出示QR碼，取得參與活動積分</div>
                                <div className="c" style={{height: "auto", margin: "0 auto", maxWidth: 125, width: "100%"}}>
                                    <QRCode
                                        size={256}
                                        style={{height: "auto", maxWidth: "100%", width: "100%"}}
                                        value={QrCode}
                                        viewBox={`0 0 256 256`}
                                    />
                                </div>
                                <div className="f"></div>
                            </div>

                            {JoinEventState !== "已參加活動，活動已開始" &&
                                <IonButton className={styles_CardDetailFor_7_2.buttonCanDo} fill={"solid"} onClick={() => _push_pg_7_3_1__quitevent(Item_Sdgs活動.Sdgs活動Id)} expand="block">
                                    取消報名
                                </IonButton>
                            }
                        </Fragment>}
                    </Fragment>
                    }

                    {!Dict_會員_Sdgs活動__參加[Item_Sdgs活動.Sdgs活動Id] && <Fragment>

                        {JoinEventState === "可參加活動" &&
                            <IonButton className={styles_CardDetailFor_7_2.buttonCanDo} fill={"solid"} onClick={() => _push_pg_7_3_1__joinevent(Item_Sdgs活動.Sdgs活動Id)} expand="block">
                                報名參加
                            </IonButton>
                        }

                        {JoinEventState !== "可參加活動" &&
                            <IonButton disabled={true} className={styles_CardDetailFor_7_2.buttonCanDo} fill={"solid"} expand="block">
                                {JoinEventState}
                            </IonButton>
                        }
                    </Fragment>
                    }


                    <div className={styles_CardDetailFor_7_3.contentBar}>
                        {/*<li className="l">介紹</li>*/}
                        <IonText className="c" dangerouslySetInnerHTML={{__html: Item_Sdgs活動.活動內容}}/>
                    </div>
                </div>

                {/*<div className={styles_CardDetailFor_7_3.containerInner}>*/}
                {/*    {(QrCode !== null) ? <>*/}
                {/*        {Item_合約獎勵.兌換時間 ? <>*/}
                {/*                <div className={styles_CardDetailFor_7_3.redeemBar}>*/}
                {/*                    <div className="l">已兌換</div>*/}
                {/*                </div>*/}
                {/*            </> :*/}
                {/*            <>*/}
                {/*                <div className={styles_CardDetailFor_7_3.redeemBar}>*/}
                {/*                    <div className="l">掃描 QR code 兌換</div>*/}
                {/*                    <div className="c" style={{height: "auto", margin: "0 auto", maxWidth: 125, width: "100%"}}>*/}
                {/*                        <QRCode*/}
                {/*                            size={256}*/}
                {/*                            style={{height: "auto", maxWidth: "100%", width: "100%"}}*/}
                {/*                            value={QrCode}*/}
                {/*                            viewBox={`0 0 256 256`}*/}
                {/*                        />*/}
                {/*                    </div>*/}
                {/*                    <div className="f"></div>*/}
                {/*                </div>*/}
                {/*            </>*/}
                {/*        }*/}
                {/*    </> : <></>}*/}

                {/*    /!*<ul className={styles_CardDetailFor_7_3.timeRangeBar}>*!/*/}
                {/*    /!*    <li className="l">使用期限</li>*!/*/}
                {/*    /!*    <div className="c">*!/*/}
                {/*    /!*        {moment(Item_合約獎勵.起始生效區間).format('YYYY/MM/DD')} - {moment(Item_合約獎勵.生效區間結束).format('YYYY/MM/DD')}*!/*/}
                {/*    /!*    </div>*!/*/}
                {/*    /!*</ul>*!/*/}

                {/*    <div className={styles_CardDetailFor_7_3.qrBar}>*/}
                {/*        /!*<li className="l">使用狀態</li>*!/*/}
                {/*        <div className="c">*/}
                {/*            每個{Item_合約獎勵._合約.Name}孵化器可兌換{Item_合約獎勵.CanUseTimesPerTokenEnw}次，您共有{總共可兌換次數}次兌換機會（目前您已兌換{已兌換次數}次，尚可兌換{Math.max(0, 總共可兌換次數 - 已兌換次數)}次）。*/}
                {/*            /!*每個數位收藏，可兌換 {Item_合約獎勵.CanUseTimesPerTokenEnw} 次，共有 {總共可兌換次數} 次兌換。已兌換 {已兌換次數} 次，尚可兌換 {總共可兌換次數 - 已兌換次數} 次。*!/*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </ActionLink>
        </>
    );
}
